import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { useSelector } from 'react-redux';
import Loading from './Loading';
import Swal from 'sweetalert2';

export default function ProtectedRoute({
  children,
  adminOnly = false,
  parentOnly = false,
  studentOnly = false,
  showMessage = true,
  redirectMessage = "يجب تسجيل الدخول أولاً لمشاهدة الكورس"
}) {
  const { isAuthenticated, isAdmin, isLoading, isParentSession, isStudentSession } = useAuth();
  const navigate = useNavigate();
  const [hasShownDialog, setHasShownDialog] = useState(false);
  const theme = useSelector((state) => state.theme.mode);

  useEffect(() => {
    if (!isLoading && !isAuthenticated && showMessage && !hasShownDialog) {
      setHasShownDialog(true);

      Swal.fire({
        title: 'يجب عليك تسجيل الدخول أولاً',
        text: redirectMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'تسجيل الدخول',
        cancelButtonText: 'إلغاء',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: theme === 'dark' ? '#2b3035' : '#fff',
        color: theme === 'dark' ? '#f8f9fa' : '#000',
        customClass: {
          popup: theme === 'dark' ? 'swal2-dark' : ''
        }
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/login', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      });
    }
  }, [isLoading, isAuthenticated, showMessage, redirectMessage, hasShownDialog, navigate, theme]);

  if (isLoading) {
    return (
      <article className='d-flex justify-content-center align-items-center min-vh-100'>
        <Loading />
      </article>
    );
  }

  if (!isAuthenticated) {
    if (!showMessage) {
      return <Navigate to="/login" replace />;
    }
    // When showMessage is true, dialog will handle navigation
    return (
      <article className='d-flex justify-content-center align-items-center min-vh-100'>
        <Loading />
      </article>
    );
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (parentOnly && !isParentSession) {
    Swal.fire({
      title: 'غير مصرح',
      text: 'هذه الصفحة مخصصة لأولياء الأمور فقط. يجب تسجيل الدخول بكود الطالب.',
      icon: 'error',
      confirmButtonText: 'تسجيل الدخول',
      confirmButtonColor: '#3085d6',
      background: theme === 'dark' ? '#2b3035' : '#fff',
      color: theme === 'dark' ? '#f8f9fa' : '#000',
    }).then(() => {
      navigate('/login', { replace: true });
    });
    return null;
  }

  if (studentOnly && !isStudentSession) {
    Swal.fire({
      title: 'غير مصرح',
      text: 'هذه الصفحة مخصصة للطلاب فقط. يجب تسجيل الدخول برقم الهاتف وكلمة المرور.',
      icon: 'error',
      confirmButtonText: 'تسجيل الدخول',
      confirmButtonColor: '#3085d6',
      background: theme === 'dark' ? '#2b3035' : '#fff',
      color: theme === 'dark' ? '#f8f9fa' : '#000',
    }).then(() => {
      navigate('/login', { replace: true });
    });
    return null;
  }

  return children;
}
